import * as React from 'react';

export const IconTwitter = (props: React.HTMLAttributes<SVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <rect fill="currentColor" width="32" height="32" rx="16" ry="16"></rect>
    {/* tslint:disable-next-line:max-line-length */}
    <path fill="#ffffff" d="M23.27 11.3a5.55 5.55 0 0 1-1.59.44 2.79 2.79 0 0 0 1.22-1.54 5.56 5.56 0 0 1-1.76.67 2.78 2.78 0 0 0-4.73 2.53 7.88 7.88 0 0 1-5.72-2.9 2.78 2.78 0 0 0 .86 3.71 2.77 2.77 0 0 1-1.26-.35 2.78 2.78 0 0 0 2.23 2.72 2.78 2.78 0 0 1-1.25 0 2.78 2.78 0 0 0 2.59 1.93 5.57 5.57 0 0 1-3.45 1.19 5.65 5.65 0 0 1-.66 0 7.9 7.9 0 0 0 12.14-6.6v-.36a5.64 5.64 0 0 0 1.38-1.44z"></path>
  </svg>
);
